export class NodeFlattener{
    public static flattenNodes(root:Node):Node[]{
        let result : Node[] = [];
        let queue:Node[] = [];
        queue.push(root);
        while(queue.length>0){
            let node = queue.shift();
            result.push(node);
            queue.push(...node.childNodes)
        }
        return result;
    }
}